import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { portalApi } from "@/lib/portalApi";
import { formatApiError } from "@/lib/api";

const ITEMS = [
  { key: "departed", label: "Vessel departed", desc: "When your shipment sails from the origin port." },
  { key: "arrived", label: "Arrived at destination", desc: "When your shipment reaches the destination port." },
  { key: "delivered", label: "Delivered", desc: "When your shipment has been delivered." },
];

function Toggle({ checked, onChange, disabled }) {
  return (
    <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={onChange}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${checked ? "bg-blue-600" : "bg-slate-300"}`}>
      <span className={`inline-block h-5 w-5 rounded-full bg-white transition-transform ${checked ? "translate-x-5" : "translate-x-0.5"}`} />
    </button>
  );
}

export default function PortalNotifications() {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    portalApi.get("/portal/notification-preferences").then(({ data }) => setPrefs(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const toggle = async (key) => {
    const prev = prefs;
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next); setSaving(true);
    try { await portalApi.put("/portal/notification-preferences", { [key]: next[key] }); }
    catch (e) { toast.error(formatApiError(e)); setPrefs(prev); }
    finally { setSaving(false); }
  };

  if (!prefs) return <div className="text-slate-400 text-sm">Loading…</div>;

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-slate-900">Email notifications</h1>
        <p className="text-slate-500 text-sm mt-1">Choose which shipment updates you'd like to receive by email.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100 max-w-2xl">
        {ITEMS.map((it) => (
          <div key={it.key} className="flex items-center justify-between gap-4 p-4">
            <div>
              <div className="text-sm font-medium text-slate-800">{it.label}</div>
              <div className="text-xs text-slate-500">{it.desc}</div>
            </div>
            <Toggle checked={!!prefs[it.key]} onChange={() => toggle(it.key)} disabled={saving} />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-3 max-w-2xl">These control shipment-status updates only. You'll still receive important account and document emails.</p>
    </div>
  );
}
